module.exports = __webpack_public_path__ + "img/service_image3.bfc89368.jpg";